import { Pipe, PipeTransform } from '@angular/core';
import { FilterScope } from '../query/paginated-request.component';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { isNullOrUndefinedOrBlank } from '../utils/is-null-or-undefined-or-blank';
import { AnnuityPatentService } from '../../data-services/annuity-patent.service';
import { PaginatedData } from '../dto/paginated-data';
import { AnnuityPatentPaginated } from '../dto/annuities/annuity-patent-paginated';

@Pipe({
  name: 'countPatents',
})
export class CountPatentsPipe implements PipeTransform {

  constructor(private annuityPatentService: AnnuityPatentService) {
  }

  public transform(query: string, scope: FilterScope, allowEmptyQuery: boolean = false): Observable<number> {
    // Note that the value needs to have something
    // (e.g. if we're counting all without a filter of blank string, this will not work)
    // No such usage exists so make the necessary adjustments like adding a parameter when comes the time.
    if (isNullOrUndefinedOrBlank(query) && !allowEmptyQuery) {
      return of(0);
    }

    const paginatedData = new PaginatedData<AnnuityPatentPaginated>();
    paginatedData.query = query;
    paginatedData.scope = scope;

    return this.annuityPatentService
      .getAllPatentCount(paginatedData)
      .pipe(
        startWith({ count: 0 }),
        map(result => result.count),
      );
  }

}
